import * as React from 'react'
import { observer } from 'mobx-react'
import {
  ModalSheet,
  ModalSheetHeader,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetContentDescription,
  ModalSheetFooter,
  ModalSheetFooterSpacer,
  ModalSheetFooterButtonGroup,
} from 'components/ModalSheet'
import Button from 'components/Button'
import OCRConfirmReviewModalViewModel from './OCRConfirmReviewModalViewModel'

/**
 * Confirm Review Modal
 */
export default observer(function OCRConfirmReviewModal({
  vm,
}: {
  vm: OCRConfirmReviewModalViewModel
}) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_create-flows.svg')}
          />
          <ModalSheetContentTitle>
            Set this job status to “Ready to Submit”
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Are you sure you want to proceed? Once you change the status, the
            Firm Admin will be able to review and submit the job.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>

      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Close</Button>
          <Button type="primary" onClick={vm.confirm}>
            Set As Ready To Submit
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
